import { useBoolean } from '@chakra-ui/react';

export const useConfirmState = (defaultValue?: boolean) => {
  const state = useBoolean(defaultValue);
  const [isOpen, { on, off }] = state;
  const result: [typeof isOpen, typeof on, typeof off, typeof state] = [isOpen, on, off, state];
  return result;
};
